import { createFileRoute } from '@tanstack/react-router';

// relative imports
import { useAccountConfig } from '../../components/providers/AccountConfigProvider';
import LoadingPage from '../../components/shared/page-components/LoadingPage';
import AccountingTransactionTable from '../../components/transactions/accounting-transactions/TransactionTablePage';
import TaxTransactionTable from '../../components/transactions/tax-transactions/TaxTransactionsPage';
import { isModuleEnabled } from '../../data/app-config/configs/configUtilities';
import { taxTransactionsSearchSchema } from '../-taxTransactionsParamsSchema';

function AppTransactions() {
  const { accountConfig } = useAccountConfig();
  const transactionsEnabled = isModuleEnabled({ moduleName: 'transactions' });
  const { transactionDataType } = accountConfig.features?.transactions || {};

  if (transactionsEnabled) {
    if (transactionDataType === 'tax') {
      return <TaxTransactionTable />;
    }
    if (transactionDataType === 'accounting') {
      return <AccountingTransactionTable />;
    }
  }

  return null;
}

export const Route = createFileRoute('/_authenticated/transactions')({
  component: AppTransactions,
  pendingComponent: () => <LoadingPage loadingPage />,
  validateSearch: (search) => {
    const parsed = taxTransactionsSearchSchema.safeParse(search);
    return parsed.success ? parsed.data : {};
  },
  staticData: {
    configPageId: 'transactions',
    meta: {
      title: 'Transactions | Ledgible',
    },
  },
});
